export { default } from './getStylesCreator';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/getStylesCreator/index.js
// module id = 487
// module chunks = 0